module.exports = __webpack_public_path__ + "img/secondary_5x3.0fc09d06.svg";